import React from "react"
import {message, Skeleton, Space, Table} from "antd"
import {SortableContainer, SortableElement, SortableHandle,} from 'react-sortable-hoc'
import {MenuOutlined} from "@ant-design/icons"
import {usePlatformSettingContext} from "../../store/usePlatformSettingContext"
import './PlatformSettingTable.css'
import {orderGrouponList} from "../../../../api/groupon"
import PlatformSettingEdit from "../PlatformSettingEdit"
import PlatformSettingDelete from "../PlatformSettingDelete"

const PlatformSettingTable = () => {

    const {platformList, isLoading, sortPlatformList, getPlatformList} = usePlatformSettingContext()

    const DragHandle = SortableHandle(() => (
        <MenuOutlined
            style={{
                cursor: 'grab',
                color: '#999',
            }}
        />
    ))

    const columns = [
        {
            title: '排序',
            dataIndex: 'sort',
            width: 100,
            className: 'drag-visible',
            render: (text, record, index) => {
                const clubId = sessionStorage.getItem('club_id')
                if (clubId === "0") {
                    return <DragHandle/>
                } else {
                    return record.clubId !== 0 ? <DragHandle/> : ''
                }
            },
        },
        {
            title: '平台ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '平台名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '操作',
            dataIndex: 'handling',
            key: 'handling',
            render(_, record) {
                if (record.clubId !== 0) {
                    return <Space>
                        <PlatformSettingEdit record={record}/>
                        <PlatformSettingDelete record={record}/>
                    </Space>
                }
            }
        }
    ]

    const SortableItem = SortableElement((props) => <tr {...props}/>)
    const SortableBody = SortableContainer((props) => <tbody {...props}/>)
    function arrayMove(array, fromIndex, toIndex) {
        const newArray = array.slice()
        const [movedItem] = newArray.splice(fromIndex, 1)
        newArray.splice(toIndex, 0, movedItem)
        return newArray
    }
    const onSortEnd = async ({oldIndex, newIndex}) => {
        if (oldIndex !== newIndex) {
            try {
                const newData = arrayMove(platformList.slice(), oldIndex, newIndex).filter(
                    (el) => !!el,
                );
                const offset = newIndex - oldIndex

                console.log('Sorted items: ', newData)
                sortPlatformList(newData)
                await orderGrouponList({
                    source: platformList[oldIndex],
                    offset: offset
                }).then(res => {
                    if (res.status !== 1) {
                        throw new Error(res.detail)
                    }
                    message.success('排序成功')
                    getPlatformList()
                })

            } catch (e) {
                message.error(`排序失败${e.message}`)
            }
        }
    }

    const DraggableContainer = (props) => (
        <SortableBody
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    )
    const DraggableBodyRow = ({className, style, ...restProps}) => {
        const index = platformList.findIndex((x) => x.id === restProps['data-row-key'])
        return <SortableItem index={index} {...restProps} />
    }

    if (isLoading) {
        return <Skeleton active></Skeleton>
    }

    return (
        <div>
            <Table
                rowKey={'id'}
                columns={columns}
                dataSource={platformList}
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                    },
                }}
            />
        </div>
    )
}

export default PlatformSettingTable


// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/components/PlatformSettingTable/PlatformSettingTable.js